import lazyLoadImagesOnTable from '../table/lazy-load-images';

const COMPARISON_CONTAINER = '.js-comparison-calculator';
const LOAD_MORE_SELECTOR = '.js-comparison-table__paginate';

function setFiltersURLParam(filters) {
  return filters
    .map(({ field, comparator, value }, idx) => [
      `filters[${idx}][field]=${field}`,
      `filters[${idx}][comparator]=${comparator}`,
      `filters[${idx}][value]=${encodeURIComponent(value)}`,
    ].join('&'));
}

function getDataTableFilter(tableFilter) {
  const { filters } = tableFilter ? JSON.parse(tableFilter) : {};
  return filters ? setFiltersURLParam(filters) : [];
}

function updateTableEvents($table) {
  const $tooltips = $table.find('[rel="popover"]');

  $table
    .trigger('update')
    .trigger('sorton');

  $tooltips
    .trigger('loadpopover');

  if ($table.length) {
    lazyLoadImagesOnTable($table[0]);
  }
}

const togglePaginationButton = (button, showButton) => {
  if (showButton) {
    button.classList.remove('is-hidden');
  } else {
    button.classList.add('is-hidden');
  }
};

const updateRowCount = (currentItemsTotal, itemsTotal) => {
  const updateFilterCounter = new CustomEvent('updateFilterCounter');
  updateFilterCounter.params = { currentItemsTotal, itemsTotal };
  document.dispatchEvent(updateFilterCounter);
};

function getNextOffset(offset = 0) {
  return Number(offset) === 0 ? 20 : offset;
}

document.addEventListener('showLoadMoreButton', (event) => {
  checkLoadMoreVisibility(event);
});

const checkLoadMoreVisibility = (event) => {
  const { currentItemsTotal, itemsTotal } = event.params;
  const buttonContainer = document.querySelector(LOAD_MORE_SELECTOR);
  if (currentItemsTotal < itemsTotal) {
    togglePaginationButton(buttonContainer, true);
  } else {
    togglePaginationButton(buttonContainer, false);
  }
};

const initPagination = ($table) => {
  const table = $table[0];
  const parent = $table.closest(COMPARISON_CONTAINER)[0];
  const button = parent.querySelector(LOAD_MORE_SELECTOR);
  const { pagination } = table.dataset || {};

  if (!pagination && !button) {
    throw new Error('Pagination not working. Check if token is set and button is existing.');
  }

  const handlePagination = (event) => {
    event.preventDefault();
    button.querySelector('button').disabled = true;

    const { category, site, fieldset, origin, tableFilter, sort } = parent.dataset;
    const filtersParam = getDataTableFilter(tableFilter);
    const offset = getNextOffset(table.dataset.paginationOffset);

    const url = [
      `${window.location.origin}/wordpress/wp-admin/admin-ajax.php?action=redraw_table_ajax`,
      'template=comparison',
      `site=${site}`,
      `category=${category}`,
      `origin=${origin}`,
      `fieldset=${fieldset}`,
      `offset=${getNextOffset(table.dataset.paginationOffset)}`,
      `page-size=${pagination}`,
      `sort=${sort}`,
      'disable_default_filter_from_filter_builder=true',
    ];

    if (filtersParam.length) {
      url.push(...filtersParam);
    }

    fetch(url.join('&'))
      .then(response => response.json())
      .then(({ html, nextOffset: showButton = false, productCount }) => {
        button.querySelector('button').disabled = false;
        $table.find('tbody').append(html);
        table.dataset.paginationOffset = Number(offset) + Number(pagination);
        updateTableEvents($table);
        togglePaginationButton(button, showButton);
        updateRowCount(parseInt(table.dataset.paginationOffset, 10), productCount);
      });
  };

  button.addEventListener('click', handlePagination);
};

export default initPagination;
